import { Outlet } from 'react-router-dom';
// @mui
import { Stack, Container } from '@mui/material';

// ----------------------------------------------------------------------

/**
 * @module Layouts/Mantainance/CompactLayout
 * @description A React functional component called `CompactLayout` is being returned. It renders a
 * `Container` component from Material-UI with a `Stack` component inside it. The `Stack` component has
 * some styling properties applied to it using the `sx` prop. The `Outlet` component is also rendered
 * inside the `Stack` component.
 * @returns {React.ReactElement} The `CompactLayout` component is being returned as a View.
 */
export default function CompactLayout() {

  return (
    <>
      <Container component="main">
        <Stack
          sx={{
            py: 12,
            m: 'auto',
            maxWidth: 400,
            minHeight: '100vh',
            textAlign: 'center',
            justifyContent: 'center',
          }}
        >
          <Outlet />
        </Stack>
      </Container>
    </>
  );
}
